import { BlogSection } from '@/types/blog';

export const landkarteSection: BlogSection = {
  id: 'landkarte',
  title: 'Die Landkarte der Finanzberatung: Wer steht in welchem Lager?',
  content: `
    <p>
      In Deutschland ist der Begriff „Finanzberater" rechtlich nicht geschützt. Um eine selbstbestimmte 
      Entscheidung zu treffen, müssen Sie verstehen, an wen jemand gebunden ist und wer ihn bezahlt.
    </p>

    <h3>Das Versicherungsspektrum nach § 34d GewO</h3>
    <p>
      Gerade bei der Altersvorsorge ist die rechtliche Stellung Ihres Gegenübers entscheidend dafür, 
      wie unabhängig die Auswahl der Produkte ist:
    </p>

    <p>
      <strong>Der gebundene Einzelvermittler (Ausschließlichkeitsvertreter):</strong> Er arbeitet exklusiv 
      für ein Versicherungsunternehmen und darf nur dessen Produkte anbieten. Er steht rechtlich im „Lager" 
      des Versicherers. Haftungsfolge: Fehler werden in der Regel dem Versicherer zugerechnet – im 
      Schadensfall haben Sie es mit einem finanzstarken Konzern als Gegner zu tun.
    </p>

    <p>
      <strong>Der Mehrfachagent:</strong> Er arbeitet mit mehreren Gesellschaften zusammen, ist jedoch 
      rechtlich ebenfalls als Interessenvertreter der Unternehmen tätig. Er bietet zwar mehr Auswahl, 
      agiert aber nicht als neutraler Sachwalter des Kunden.
    </p>

    <p>
      <strong>Der Versicherungsmakler:</strong> Er ist der einzige Typus, der rechtlich als 
      „treuhänderischer Sachwalter des Kunden" definiert ist (§ 59 VVG). Er ist an keine Gesellschaft 
      gebunden und verpflichtet, aus einer hinreichenden Marktauswahl die beste Lösung für Sie zu finden. 
      Er haftet persönlich für seine Beratung.
    </p>

    <h3>Finanzanlagenvermittlung, Honorarberatung und § 34k</h3>
    <p>
      Ergänzend dazu finden wir den <strong>Finanzanlagenvermittler</strong> (§ 34f GewO), der meist 
      provisionsbasiert arbeitet, und den <strong>Honorar-Finanzanlagenberater</strong> (§ 34h GewO), 
      der ausschließlich vom Kunden bezahlt wird. Ab dem 20. November 2026 wird zudem die Vermittlung 
      von Verbraucherkrediten im neuen § 34k GewO eigenständig geregelt, was die Anforderungen an 
      Sachkunde und Zuverlässigkeit weiter verschärft.
    </p>

    <div class="bg-muted/40 p-5 rounded-lg my-6 border-l-4 border-primary/40">
      <p class="font-medium text-foreground mb-2">Meine Positionierung</p>
      <p class="text-muted-foreground leading-relaxed">
        Als Geprüfter Fachwirt für Finanzberatung (IHK), eingestuft als Bachelor Professional of Financial 
        Advisory (DQR-6), kenne ich die regulierte Welt von innen. Ich habe als Makler gearbeitet, die 
        Zusatzqualifikation Zertifizierter ETF-Consultant (VDH) erworben und Konzepte für die 
        Implementierung der unabhängigen Honorarberatung entwickelt.
      </p>
      <p class="text-muted-foreground leading-relaxed mt-3">
        Dennoch habe ich mich bewusst gegen eine Tätigkeit in der Honorarberatung entschieden. Mein Ziel 
        ist nicht die Depotoptimierung gegen Gebühr, sondern die Begleitung des Menschen im Coaching-Prozess 
        zur Erlangung echter finanzieller Souveränität.
      </p>
    </div>
  `
};
